<template>
  <div class="books">
    <div v-show="showTitle" class="title row">
      <i></i>
      <span class="flex cc">{{title}}</span>
      <a v-if="showRefresh" class="ccc refresh" @click="showRefreshAction">换一批</a>
      <a v-if="showMore" class="cc more" @click="showMoreAction">更多</a>
    </div>
    <ul v-if="books && books.length > 0" class="booklist">
      <li v-for="(item, index) in books" :key="index">
        <a class="cc" @click="toBookDetail(item.bookId)">
          <div class="pic">
            <img :bookid="item.bookId" :booktitle="item.title" :chapternum="0" :imgpath="item.cover" :zoom="1000" v-lazy="require('../../assets/images/loading.jpeg')" :alt="item.title"/>
            <span v-if="item.showPop" :class="['book-pop', item.popClass]"></span>
            <span class="name">{{item.title}}</span>
          </div>

          <p v-if="!singleMode && item.publishStatus === 'finish'" class="book-sum">
            <span>共<i class="c-g">{{item.chapterCount}}</i>话</span>
            <span class="tag-green">{{getPublishStatusText(item.publishStatus)}}</span>
          </p>

          <p v-if="!singleMode && item.publishStatus !== 'finish'" class="book-sum">
            <span>更新至第<i>{{item.chapterCount}}</i>话</span>
            <span class="tag-red">{{getPublishStatusText(item.publishStatus)}}</span>
          </p>
        </a>
        <div v-if="atShelf" class="col"><a class="btn btn-o cancel" @click="addShelf(item)">取消订阅</a></div>
      </li>
    </ul>
    <div v-else class="h400">
      <div class="no_book">
        <p>暂时没有记录</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {getImg} from "../../services/urlService";
  import {getImgPlaceholder} from "../../services/urlService";
  import shelfService from "../../services/shelfService";

  export default {
    name: "books-small",
    props: {
      title: String,
      books: Array,
      showTitle: {
        type: Boolean,
        default: true
      },
      showMore: {
        type: Boolean,
        default: true
      },
      showRefresh: {
        type: Boolean,
        default: false
      },
      singleMode: {
        type: Boolean,
        default: false
      },
      addedToShelf: true,
      atShelf: {
        type: Boolean,
        default: false
      },
      currentPage: 1,
    },
    data() {
      return {}
    },
    methods: {
      toBookDetail(id) {
        this.$router.isBack = false;
        this.$router.push(`/book/${id}`)
      },
      showMoreAction() {
        this.$emit('show-more');
      },
      showRefreshAction(){
        this.$emit('show-refresh');
      },
      getPublishStatusText(code) {
        if (code === 'finish') {
          return '完结'
        } else {
          return '连载'
        }
      },
      addShelf(bookInfo) {
        this.addedToShelf = shelfService.addShelf(bookInfo);
        this.$router.go(0);
      },
    },
    watch: {
      books(data) {
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/share/books-small.vue